export const SCENEWEAVE_GITHUB_URL = 'https://github.com/Aolin-MIR/SceneWeave';
